<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { onApiConnectivity } from '@/api/client';

const { t } = useI18n();
const online = ref(true);

onMounted(() => {
  onApiConnectivity((ok) => {
    online.value = ok;
  });
});
</script>

<template>
  <div
    v-if="!online"
    role="status"
    aria-live="polite"
    class="bg-[color:var(--lv-status-bad)] text-[color:var(--lv-surface)] text-sm px-4 py-2 text-center"
  >
    <i class="pi pi-exclamation-triangle mr-2" />
    {{ t('connectivity.offline') }}
  </div>
</template>
